import modulePaths from 'constants/modulePath';
import moduleCodes from 'constants/moduleCodes';
import routePath from 'constants/routePath';

export const get2bapLearnersModuleUrl = () =>
  `/${modulePaths[moduleCodes.MODULE_2BAP]}/${routePath.ROUTE_2BAP_EXTERNAL_LEARNERS_MODULE}`;

export const get2bapLearnersSummaryViewUrl = () =>
  `${get2bapLearnersModuleUrl()}/${routePath.ROUTE_2BAP_EXTERNAL_LEARNERS_MODULE_SUMMARY_VIEW}`;
